<template>
    <div>
        <v-server-table ref="divisionsTable" url="/admin/divisions-list" :columns="columns" :options="options">

            <template slot="DivisionId" slot-scope="props">
                <div style="display: inline-flex;">
                    <router-link :to="`/admin/divisions-edit/${props.row.DivisionId}`" title="Edit Division" class="btn btn-sm btn-default">
                        <i class="fa fa-edit"></i> Edit
                    </router-link>
                    &nbsp; &nbsp;
                    <router-link :to="`/admin/divisions-delete/${props.row.DivisionId}`" title="Delete Division" class="btn btn-sm btn-default">
                        <div class="text-danger"><i class="fa fa-trash"></i> Delete</div>
                    </router-link>
                </div>
            </template>

            <template slot="IsActive" slot-scope="props">
                <label :class="`text-${props.row.IsActive == 1 ? 'success' : 'danger'}`">
                    {{ props.row.IsActive == 1 ? 'Active' : 'Inactive' }}
                </label>
            </template>

            <template slot="pdf_logo" slot-scope="props">
                <a :href="props.row.pdf_logo" target="blank" v-if="props.row.pdf_logo">{{ getLogoFileName(props.row.pdf_logo) }}</a>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                columns: ['DivisionId', 'division_code', 'DivisionName', 'IsActive', 'pdf_logo'],
                options: {
                    headings: {
                        DivisionId: 'Action',
                        division_code: 'Division Code',
                        DivisionName: 'Division Name',
                        IsActive: 'Is Active',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'division.DivisionName',
                    },
                    uniqueKey: 'DivisionId',
                },
            }
        },

        methods: {

            getLogoFileName(file_path){
                //Split on the "/"
                var parts = file_path.split("/");

                //Send the laset one
                return parts[(parts.length - 1)];
            }
        }
    }
</script>
